<template>
    <div class="calculatorItemContianer">
        <div class="sessionBox">
            <div class="itemName">
				{{ name }}
				<el-select
					style="width: 148px"
					v-model="itemProvience"
					placeholder="请选择"
					@change="handleChange"
					>
					<el-option
						v-for="item in cityList"
						:key="item"
						:label="item"
						:value="item"
						>
					</el-option>
				</el-select>
			</div>
            <div class="introduceBox">
                <div class="lable">数据输入</div>
                <div class="content">
                    <i class="el-icon-warning"></i>
                    输入相关项目数值信息，可完成基础取费计算
                </div>
            </div>
            <slot name="form"></slot>
            <div class="btnBox">
                <el-button type="primary" @click="$emit('submit')">开始计算</el-button>
            </div>
        </div>
        <div class="sessionBox">
			<i
				class="el-icon-close"
				@click="handleClose"
				>
			</i>
			<div class="introduceBox">
				<div class="lable">计算结果</div>
			</div>
			<!-- <div v-if="!result.jsMap"> -->
			<div>
				<div v-if="result.discountRatio !== '/'">
					<div
						class="introduceBox"
						>
						<div class="resultBox">
							折前费：<span class="result">{{result.beforeSummation}}</span> <span>元</span>
						</div>
					</div>
					<div class="introduceBox">
						<div class="resultBox">
							折后费：<span class="result">{{result.summation}}</span> <span>元</span>
							<!-- {{ hideBeforeSummation ? '费用：' : '折后费：' }}<span class="result">{{result.summation}}</span> <span>万元</span> -->
						</div>
					</div>
				</div>
				<div v-else>
					<div class="introduceBox">
						<div class="resultBox">
							费用：<span class="result">{{result.summation}}</span> <span>元</span>
						</div>
					</div>
				</div>
				<div
					v-if="result.lowestFee"
					class="introduceBox"
					>
					<div class="resultBox">
						{{ result.lowestFee }}
					</div>
				</div>
			</div>
			<!-- <div v-else>
				<div
					class="introduceBox"
					v-for="(value, key) in result.jsMap"
					:key="key"
					>
					<div class="resultBox">{{ key }}：
						<span class="result">{{value}}</span>
						<span>万元</span>
					</div>
				</div>
				<div class="introduceBox">
					<div class="resultBox">折前费：<span class="result">{{result.beforeSummation}}</span> <span>万元</span></div>
				</div>
				<div class="introduceBox">
					<div class="resultBox">折后费：<span class="result">{{result.summation}}</span> <span>万元</span></div>
				</div>
			</div> -->
            <div
				class="introduceBox"
				v-if="basicCriterion.priceDescribe"
				>
                <div class="lable">计算说明</div>
            </div>
            <div
				class="progressIntroduceBox"
				v-if="basicCriterion.priceDescribe"
				>
				<div>计算依据：
					<span
						:class="basicCriterion.describeValue ? 'basicCriterion' : ''"
						@click="showFilePreview"
						>
						{{ basicCriterion.priceDescribe }}
					</span>
				</div>
            </div>
        </div>
		<PreviewFile ref="previewFile"/>
    </div>
</template>
<script>

import PreviewFile from './PreviewFile.vue'

export default {
	components: {
		PreviewFile
	},
    props: {
        result: {
            type: Object,
            default: () => {}
        },
        name: {
            type:String,
            default: ''
        },
		provience: {
            type:String,
            default: ''
        },
		hideBeforeSummation: {
			type: Boolean,
			default: false
		},
		basicCriterion: {
			type: Object,
            default: () => {}
		}
    },
    data() {
        return {
			cityList: [],
			itemProvience: '',
			pageUrl: ''
        }
    },
    methods: {
		handleClose() {
			this.$parent.$parent.handleChangeType(this.name)
		},

		handleChange(value) {
			this.$emit('handleProvienceChange', {
				cityName: value,
				submitFlag: false
			})
		},

		handleAllProvienceChange(value) {
			if(this.cityList.includes(value)){
				this.itemProvience = value
			}else{
				this.itemProvience = this.cityList[0]
			}
			this.$emit('handleProvienceChange', {
				cityName: this.itemProvience,
				submitFlag: false
			})
		},

		// 获取省份
        getCityList() {
            this.$get('/web/yzkjhz/hz/cityList', {
				baseName: this.name,
				isJsq: '2'
			}, res => {
				this.cityList = res
				if(this.provience){
					if(this.cityList.includes(this.provience)){
						this.itemProvience = this.provience
					}else{
						this.itemProvience = this.cityList[0]
					}
				}else{
					this.itemProvience = this.cityList[0]
				}
				this.$emit('handleProvienceChange', {
					cityName: this.itemProvience,
					submitFlag: false
				})
            })
        },

		showFilePreview() {
			if(!this.basicCriterion.describeValue) return
			this.$refs.previewFile.show(this.basicCriterion.priceDescribe, this.basicCriterion.describeValue)
		}
    },
	mounted() {
		this.getCityList()
	}
}
</script>

<style lang="scss" scoped>
	.calculatorItemContianer {
		display: flex;
		border-radius: 5px;
		overflow: hidden;
		margin-bottom: 20px;

		.sessionBox {
			position: relative;
			width: 50%;
			background: white;
			padding: 20px;

            .itemName {
                position: absolute;
                top: 0;
                left: 0;
                background: #3D7EFF;
                border-radius: 0px 0px 20px 0px;
                height: 40px;
                line-height: 40px;
                font-size: 18px;
                color: #FFFFFF;
                padding: 0 30px 0 16px;
				font-weight: 700;
				/deep/.el-input__inner {
					line-height: 32px;
					height: 32px;
				}
			}

			.title {
				text-align: center;
				font-size: 18px;
				font-weight: 700;
				padding-bottom: 10px;
			}

			.btnBox {
				cursor: pointer;
				width: 136px;
				height: 60px;
				line-height: 60px;
				text-align: center;
				position: absolute;
				right: -68px;
				top: calc(50% - 20px);
				background-image: url('@/assets/images/calculter/arrow.png');
				color: white;
				z-index: 2;
				background-size: cover;
				.el-button {
					background: none;
					border: none;
				}
			}

			// .borderLine {
			// 	border-bottom: 1px solid #dcdcdc;
			// 	width: calc(100% + 40px);
			// 	margin-left: -20px;
			// }

			.introduceBox {
				overflow: hidden;
				padding-top: 20px;

				.lable {
					float: left;
					width: 90px;
					position: relative;
					padding-left: 10px;
					color: #333;
					font-size: 16px;
					font-weight: 600;
				}

				.lable::after {
					content: "";
					position: absolute;
					width: 5px;
					height: 15px;
					top: 3px;
					left: 0;
					background-color: rgba(31, 128, 234, 1);
				}

				.content {
					float: left;
					width: calc(100% - 90px);
					padding-bottom: 20px;
				}
			}

			.progressIntroduceBox {
				background: #EFF6FF;
				border-radius: 5px;
				padding: 20px;
				margin-top: 10px;
				line-height: 30px;

				.basicCriterion {
					color: #2f74ff;
					cursor: pointer;
				}
			}

			.hoverTip {
				margin-top: -10px;
				padding-left: 100px;
				margin-bottom: 10px;
				color: red;
			}

			.otherForm {
				width: 500px;
				margin: 10px auto;
			}

			.otherForm {
				border: none;
				float: none;
				box-shadow: none;
			}

			.el-icon-close {
				position: absolute;
				top: 16px;
				right: 16px;
				font-size: 20px;
				cursor: pointer;
				background: #888888;
				color: white;
				border-radius: 50%;
				padding: 2px;
				z-index: 2;
			}
		}

		.sessionBox:first-child {
			.introduceBox {
				width: 500px;
				margin: 20px auto 0;
				.content {
					color: #666666;
				}
			}
		}

		.sessionBox:first-child::after {
			content: '';
			position: absolute;
			width: 1px;
			height: calc(100% - 76px - 76px);
			background: #dcdcdc;
			top: 76px;
			right: 0;
		}

		.sessionBox:last-child {
			padding-left: 110px;
		}
	}

	.resultBox {
		display: flex;
		align-items: center;
	}

	.result {
		color: red;
		font-size: 20px;
		padding-right: 10px;
		margin-top: -5px;
	}
</style>
